import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../shared/core2Config';
import { UserNotificationLinkViewerContainerModel } from '../../../../../models/aggregates/user-notification-link-viewer';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class UserNotificationLinkViewerService extends BaseApiPublicLoginTemplateService<UserNotificationLinkViewerContainerModel,UserNotificationLinkViewerContainerModel,UserNotificationLinkViewerContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'user-notification-link-viewers/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'user-notification-link-viewers/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'user-notification-link-viewers/' + Core2Config.PUBLIC_EP_SUFFIX;
    this.httpClient = http;
  }
}